import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

/**
 *  @description
 *  This module manages the state of a single transaction.
 */
const CartModule = {
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
}

export default CartModule
